<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <template v-if="model">
      <page-header-new :title="title" :breadcrumbs="breadcrumbs">
        <template slot="actions" v-if="!readonly">
          <list-export-button
            :list-id="listId"
            v-if="$can('UserPersonalData::Export')"
          />
          <list-import-button :list-id="listId" />
          <el-button
            @click="addItem"
            type="primary"
            icon="el-icon-plus"
            data-qa="add-new-item-button"
          >
            {{ $t('Lists_ListItemsList_Create') }}
          </el-button>
        </template>
      </page-header-new>

      <page-content>
        <rest-list-editable
          ref="items"
          :payload="fetchItemsEndpoint"
          :add-endpoint="rowAddEndpoint"
          :additional-payload="{ list_id: listId }"
        >
          <template>
            <rest-list-column
              prop="value"
              :title="$t('ListItem_Field_Value')"
              :filterable="true"
              :editable="true"
            ></rest-list-column>

            <rest-list-column-actions v-if="!readonly" :editable="true">
              <template slot-scope="scope">
                <rest-list-action-delete
                  :endpoint="rowDeleteEndpoint(scope.row)"
                  :name="scope.row.value"
                />
              </template>
            </rest-list-column-actions>
          </template>
        </rest-list-editable>
      </page-content>
    </template>
  </rest-page>
</template>

<script>
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageContent from '@/common/components/page/PageContent'
import RestPage from '@/common/components/rest/RestPage'
import RestListEditable from '@/common/components/rest/RestListEditable'
import ListImportButton from '@/modules/audiences/components/ListImportButton'
import ListExportButton from '@/modules/audiences/components/ListExportButton'
import { integrationsTypes } from '@/modules/integrations/enum/IntegrationsEnum'
import iframeTitleMixin from '@/common/mixins/iframeTitleMixin'

export default {
  mixins: [iframeTitleMixin],

  components: {
    ListExportButton,
    ListImportButton,
    RestListEditable,
    RestPage,
    PageContent,
    PageHeaderNew,
    RestListColumn,
    RestListColumnActions,
    RestListActionDelete
  },

  props: {
    suppress: {
      type: Number,
      required: true
    },
    externalType: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      model: null
    }
  },

  computed: {
    title() {
      return this.model ? this.model.name : null
    },

    breadcrumbs() {
      let goBackRoute = 'AudienceUserList'
      let lastBreadcrumbItem = 'Audiences_Breadcrumb_UserList'
      if (this.suppress) {
        goBackRoute = 'AudienceSuppressionList'
        lastBreadcrumbItem = 'Audiences_Breadcrumb_SuppressionList'
      } else if (this.externalType === integrationsTypes.sportradar) {
        goBackRoute = 'AudienceSportradarList'
        lastBreadcrumbItem = 'Audiences_Breadcrumb_SportradarList'
      } else if (this.isOptimoveList) {
        goBackRoute = 'AudienceOptimoveList'
        lastBreadcrumbItem = 'Audiences_Breadcrumb_OptimoveList'
      }

      return [
        {
          label: 'Data'
        },
        {
          label: this.$t('Audiences_Breadcrumb_Audiences'),
          route: projectRoute({ name: goBackRoute })
        },
        {
          label: this.$t(lastBreadcrumbItem)
        }
      ]
    },

    listId() {
      return this.$route.query.list_id
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `lists/${this.$route.query.list_id}`,
        handler: model => {
          this.model = model
        }
      })
    },

    fetchItemsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `lists/${this.$route.query.list_id}/items`,
        params: {}
      })
    },

    rowAddEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `lists/${this.$route.query.list_id}/items`
      })
    },

    readonly() {
      return !this.$can('updateProjectItem')
    },

    isOptimoveList() {
      return this.externalType === integrationsTypes.optimove
    }
  },

  methods: {
    addItem() {
      this.$refs['items'].addRow({})
    },

    rowDeleteEndpoint(row) {
      const encodedValue = encodeURIComponent(row.value)
      return projectEndpoint({
        method: 'delete',
        url: `lists/${this.$route.query.list_id}/items/${encodedValue}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/BaseListItems.vue